import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { playerFactory, SharedModule } from '@presentation/view/shared/shared.module';
import { AppMaterialModule } from 'src/app/app-material.module';
import { NgxMaskModule } from 'ngx-mask';
import { ReservationComponent } from './reservation.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DriverComponent } from '../driver/driver.component';
import { DriverModule } from '../driver/driver.module';
import { VehiclesComponent } from '../vehicles/vehicles.component';
import { LottieModule } from 'ngx-lottie';
import { AdditionalsComponent } from '../additionals/additionals.component';
import { PersonComponent } from '../person/person.component';
import { PaymentComponent } from '../payment/payment.component';
import { ImageUploadComponent } from '@presentation/view/shared/components/anexos/image-upload/image-upload.component';



@NgModule({
  declarations: [ReservationComponent, VehiclesComponent, AdditionalsComponent, PersonComponent, PaymentComponent, ImageUploadComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    AppMaterialModule,
    MatStepperModule,
    ReactiveFormsModule,
    SharedModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
  ],
  
})


export class ReservationModule { }
